// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"322":"17c35402","668":"7f7a978e","818":"7f7a978e"}[chunkId] + ".chunk.css";
};